export default {
  name: 'capitalize',
  fn: (val: string) => `${val.charAt(0).toUpperCase()}${val.slice(1)}`,
};
